package com.exura.features.plandefinition.domain.builder

/**
 * Wraps a builder field with change tracking and validation
 */
data class BuilderField<S>(
    private var value: S? = null,
    private var isChanged: Boolean = false,
    private val isRequired: Boolean = false,
    private val default: S? = null,
    private val validator: (S) -> Boolean = { true }
) {

    /**
     * Gets the current value, falling back to default if not set
     */
    fun getValue(): S? {
        return value ?: default
    }

    /**
     * Sets a new value and marks as changed if different
     */
    fun setValue(newValue: S?): Boolean {
        if (value != newValue) {
            value = newValue
            isChanged = true
        }
        return isChanged
    }

    /**
     * Checks if this field has been changed from its initial state
     */
    fun hasChanged(): Boolean = isChanged

    fun markChanged() {
        isChanged = true
    }

    fun markSaved() {
        isChanged = false
    }

    /**
     * Validates the field with both required check and custom validator
     */
    fun validate() {
        if (isRequired) {
            when  {
                (getValue() == null) -> throw IllegalStateException("Required field cannot be null")
                !validator(getValue()!!) -> throw IllegalStateException("Custom validation failed for field")
            }
        }
    }

}
